var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
import { CircleAdd } from '../../foundations/icons';
import { Typography } from '../../foundations/typography';
import styles from './AddButton.module.scss';
/**
 * @tdr
 * TODO: support multiple components with the same candidate (e.g. Button and AddButton or TextLink and LinkAsButton)
 * @tdr-candidates: button
 */
export var AddButton = function (_a) {
    var _b;
    var label = _a.label, _c = _a.alignment, alignment = _c === void 0 ? 'center' : _c, _d = _a.hasError, hasError = _d === void 0 ? false : _d, className = _a.className, props = __rest(_a, ["label", "alignment", "hasError", "className"]);
    return (React.createElement(Typography, __assign({ element: "button", styleAs: "paragraph", noMargins: true, type: "button", className: classnames(styles.button, styles[alignment], className, (_b = {},
            _b[styles.hasError] = hasError,
            _b)) }, props),
        React.createElement(CircleAdd, { className: styles.icon, "data-testid": "add-icon" }),
        label));
};
//# sourceMappingURL=AddButton.js.map